export default {
    namespaced: true,
    state: {
        list: [],
        listGroup: []
    },
    getters: {
        list: (state) => state.list,
        listArray(state) {
            let keys = [];
            for (let a in state.list) {
                keys.push({
                    sku: a,
                    name: state.list[a].name,
                    sn_length: state.list[a].sn_length,
                    has_order_number: state.list[a].has_order_number
                });
            }
            return keys;
        },
        listGroup(state) {
            return state.listGroup;
        }
    },
    mutations: {
        mainProductMutate(state, data) {
            state.list = data;
        },
        mainProductGroupMutate(state, data) {
            state.listGroup = data;
        }
    },
    actions: {
        setMainProduct(context, data) {
            context.commit('mainProductMutate', data);
        },
        setMainProductGroup(context, data) {
            context.commit('mainProductGroupMutate', data);
        }
    }
};
